// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__h8Y4v","thumb":"Switch_thumb__w2D32","thumbOn":"Switch_thumbOn__8inkh","thumbOff":"Switch_thumbOff__JZgYY"};